(function($) {
  if ($(".pregnancy-form").length) {
    // update calendar on changing date
    $(".pregnancy-form").on("change", "#datepicker", function() {
      refreshData();
    });

    // on form submit
    $(".pregnancy-form").on("submit", function(e) {
      e.preventDefault();
      refreshData();
      $(".pregnancy-calendar-section").slideDown();
    });
  }

  // refresh data based on chosen calendar date
  function refreshData() {
    var avgPregDays = 280;
    var pregDate = $(".pregnancy-form #datepicker").val();
    
    if (!pregDate) {
      return;
    }
    
    // Map siteLang to regional code
    var regionalMap = {
      'NO': 'no',
      'SV': 'sv',
      'DK': 'da',
      'FI': 'fi',
      'EN': 'en'
    };
    
    var region = regionalMap[siteLang] || 'sv';
    
    // Parse date based on format (handle both . and / separators)
    var splitDate;
    if (pregDate.indexOf('/') > -1) {
      // English format: dd/mm/yy
      splitDate = pregDate.split("/");
    } else {
      // Nordic format: dd.mm.yy
      splitDate = pregDate.split(".");
    }
    
    var pDate = new Date(splitDate[2], splitDate[1] - 1, splitDate[0]);
    var nDate = new Date(pDate);
    var today = new Date();
    today.setDate(today.getDate() - 1);
    nDate.setDate(nDate.getDate() + avgPregDays + 1);
    var weeks = 0;
    var days = 0;
    var diffDays = 0;
    
    // Language-specific translations
    var translations = {
      'no': { days: ' dager' },
      'sv': { days: ' dagar' },
      'da': { days: ' dage' },
      'fi': { days: ' päivää' },
      'en': { days: ' days' }
    };
    
    var langDays = translations[region].days;
    
    // Calculate weeks and days
    if (today.valueOf() >= pDate.valueOf()) {
      var timeDiff = Math.abs(pDate.getTime() - today.getTime());
      diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
      days = diffDays;
      if (diffDays >= 7) {
        weeks = Math.floor(diffDays / 7);
        days = diffDays % 7;
      }
    }
    
    var pregChance = days + langDays;
    if (diffDays && weeks > 0) {
      pregChance = weeks + " + " + days + langDays;
    }

    // Format delivery date using jQuery datepicker
    var deliveryDate;
    
    // Check if regional settings are available
    if ($.datepicker && $.datepicker.regional && $.datepicker.regional[region]) {
      // Finnish month names in partitive case (used in date ranges)
      if (region === 'fi') {
        var monthNamesShortFi = [
          "tammikuuta",
          "helmikuuta",
          "maaliskuuta",
          "huhtikuuta",
          "toukokuuta",
          "kesäkuuta",
          "heinäkuuta",
          "elokuuta",
          "syyskuuta",
          "lokakuuta",
          "marraskuuta",
          "joulukuuta"
        ];
        $.extend($.datepicker.regional[region], {monthNamesShort: monthNamesShortFi});
      }
      
      var deliveryDateFormat = region === 'fi' ? 'd. M yy' : 'd M yy';
      deliveryDate = $.datepicker
        .setDefaults($.datepicker.regional[region])
        .formatDate(deliveryDateFormat, nDate);
    } else {
      // Fallback if datepicker regional settings not available yet
      var months = {
        'sv': ['jan', 'feb', 'mar', 'apr', 'maj', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'],
        'no': ['jan', 'feb', 'mar', 'apr', 'mai', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'des'],
        'da': ['jan', 'feb', 'mar', 'apr', 'maj', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'],
        'fi': ['tammikuuta', 'helmikuuta', 'maaliskuuta', 'huhtikuuta', 'toukokuuta', 'kesäkuuta', 'heinäkuuta', 'elokuuta', 'syyskuuta', 'lokakuuta', 'marraskuuta', 'joulukuuta'],
        'en': ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
      };
      
      var monthNames = months[region] || months['sv'];
      var day = nDate.getDate();
      var month = monthNames[nDate.getMonth()];
      var year = nDate.getFullYear();
      
      deliveryDate = region === 'fi' ? day + '. ' + month + ' ' + year : day + ' ' + month + ' ' + year;
    }

    $("#pregnancy-chance").text(pregChance);
    $("#pregnancy-date").text(deliveryDate);
  }
})(jQuery);
